import { UsePlansConfig, UsePlansResponse, usePlansSWR } from './usePlansSWR'
import { usePlanPricingGroup } from './usePlanPricingGroup'

export type UseCurrentPlansConfig = UsePlansConfig
export type UseCurrentPlansResponse = UsePlansResponse

/**
 * Wraps useSWR to retrieve subscription plans from the api, based
 * on what the current user is allowed to see and select from.
 */
export function useCurrentPlansSWR(config?: UseCurrentPlansConfig): UseCurrentPlansResponse {
  const group = usePlanPricingGroup()
  return usePlansSWR(() => {
    return { filter: { groupEq: group } }
  }, config)
}
